import { gql } from '@apollo/client'

export const deleteUserAccountRequest = gql`
  mutation DeleteUserAccountRequest {
    deleteUserAccountRequest
  }
`
